<template>
  <main class="flex-1 overflow-auto bg-gray-100">
    <div class="container mx-auto px-6 py-4">
      <slot name="alerts"></slot>
      <div v-if="$slots.header" class="mb-6">
        <slot name="header"></slot>
      </div>
      <slot></slot>
    </div>
  </main>
</template>

<script setup>
</script> 